/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_NavigationInputs */

const en_loading_navigation = /** @type {(inputs: Loading_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening the page…`)
};

const id_loading_navigation = /** @type {(inputs: Loading_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membuka halaman…`)
};

/**
* | output |
* | --- |
* | "Opening the page…" |
*
* @param {Loading_NavigationInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_navigation = /** @type {((inputs?: Loading_NavigationInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_NavigationInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_navigation(inputs)
	return en_loading_navigation(inputs)
});